import React, { useState, useEffect } from "react"
import Select from "react-select"
import MetaTags from "react-meta-tags"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  Row,
  UncontrolledTooltip,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import "react-datepicker/dist/react-datepicker.css"
import Breadcrumbs from "components/Common/Breadcrumb"
import FieldValidation from "../../../components/Common/FieldValidation"
import { API_URL, sitename } from "../../../constants/constants"
import axios from "axios"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

const Create = props => {
  const [start_date, setStartDate] = useState("")
  const [end_date, setEndDate] = useState("")
  const [supplier, setSupplier] = useState(null)
  const [product, setProduct] = useState(null)
  const [timePeriod, setTimePeriod] = useState(null)
  const [provider, setProvider] = useState(null)
  const [game, setGame] = useState(null)
  const [betsOptions, setBetsOptions] = useState([])
  const [dominationOptions, setDominationOptions] = useState([])
  const [providerOptions, setProviderOptions] = useState([])
  const [providerWiseGamesOptions, setProviderWiseGamesOptions] = useState([])
  const [gameWiseDominationOptions, setGameWiseDominationOptions] = useState([])
  const [gameWiseBetsOptions, setGameWiseBetsOptions] = useState([])
  const [gameWiseTotalBetsOptions, setGameWiseTotalBetsOptions] = useState([])
  const [quanty, setQuanty] = useState("")
  const [player, setPlayer] = useState("")
  const [deposit, setDeposit] = useState("")
  const [freespin, setFreespin] = useState("")
  const [formErrors, setFormErrors] = useState({})
  const [bets, set_bets] = useState()
  const [selected_bet, set_selected_bet] = useState({})

  const handleStartDateChange = e => setStartDate(e.target.value)

  const handleEndDateChange = e => {
    const inputEndDate = e.target.value
    const startDateTime = new Date(start_date).getTime()
    const endDateTime = new Date(inputEndDate).getTime()

    if (endDateTime < startDateTime) {
      setFormErrors({
        ...formErrors,
        end_date: "End date cannot be before the start date.",
      })
    } else {
      setFormErrors({
        ...formErrors,
        end_date: "",
      })
    }

    setEndDate(inputEndDate)
  }

  const getUnixTime = date => new Date(date).getTime() / 1000

  useEffect(() => {
    fetchProviderOptions()
    handleGenerateID()
  }, [])

  useEffect(() => {
    if (provider) {
      fetchProviderWiseGamesOptions(provider.value)
    } else {
      setGame(null)
      setBetsOptions([])
      setDominationOptions([])
      set_selected_bet({})
    }
  }, [provider])

  useEffect(() => {
    if (game) {
      fetchGameWiseOptions(game.value)
    } else {
      setBetsOptions([])
      setDominationOptions([])
      set_selected_bet({})
    }
  }, [game])

  const handleGenerateID = () => {
    setFreespin(generateRandomID())
  }

  function generateRandomID() {
    const chars = "0123456789abcdef"
    let result = ""
    for (let i = 0; i < 8; i++) result += chars[Math.floor(Math.random() * 16)]
    result += "-"
    for (let i = 0; i < 4; i++) result += chars[Math.floor(Math.random() * 16)]
    result += "-"
    result += "4" // UUID version 4
    for (let i = 0; i < 3; i++) result += chars[Math.floor(Math.random() * 16)]
    result += "-"
    result += "89ab"[Math.floor(Math.random() * 4)] // UUID variant
    for (let i = 0; i < 3; i++) result += chars[Math.floor(Math.random() * 16)]
    result += "-"
    for (let i = 0; i < 12; i++) result += chars[Math.floor(Math.random() * 16)]
    return result
  }

  const handleSubmit = async e => {
    e.preventDefault()

    const errors = {}
    if (!start_date) errors.start_date = "Start date is required."
    if (!end_date) errors.end_date = "End date is required."
    if (!supplier) errors.supplier_id = "Currency selection is required."
    if (!provider) errors.provider_id = "Provider selection is required."
    if (!product) errors.product_id = "product selection is required."
    if (!timePeriod) errors.timePeriod_id = "Time Period selection is required."
    if (!game) errors.game_id = "Game selection is required."
    if (!dominationOptions)
      errors.dominationOptions_id = "Donomination selection is required."
    if (!betsOptions) errors.bet_id = "Bets selection is required."

    if (Object.keys(errors).length) {
      setFormErrors(errors)
      return
    }

    setFormErrors({})

    const requestData = {
      player_id: player,
      player_name: player,
      quantity: quanty,
      valid_from: getUnixTime(start_date),
      valid_until: getUnixTime(end_date),
      freespin_id: freespin,
      bet_id: betsOptions?.value || null,
      total_bet_id: gameWiseTotalBetsOptions?.[0]?.value || null,
      denomination: dominationOptions?.value || null,
      game_uuid: game?.value,
      type: 1,
      deposit: deposit,
      product: product.value,
      timePeriod:timePeriod.value,
    }

    try {
      const response = await axios.post(
        `${API_URL}/slotegrator/autofreeSpin`,
        requestData
      )
      toastr.success(
        response?.data?.message || "Free Spin data submitted successfully"
      )
      setTimeout(() => {
        props.history.push("/promotions/AutometedFreeSpin")
      }, 1000)
    } catch (error) {
      toastr.error(
        error?.response?.data?.message || "Error submitting Free Spin data"
      )
    }
  }

  const fetchProviderOptions = () => {
    axios
      .get(`${API_URL}/slotegrator/game-provider`)
      .then(response => {
        const providers = response?.data?.data || []
        setProviderOptions(
          providers.map(provider => ({
            value: provider.id,
            label: provider.name,
          }))
        )
      })
      .catch(error => {
        toastr.error(
          error?.response?.data?.message || "Error fetching provider options"
        )
      })
  }

  const fetchProviderWiseGamesOptions = providerId => {
    axios
      .get(`${API_URL}/slotegrator/AllGames?provider=${providerId}`)
      .then(response => {
        const games = response?.data?.data || []
        setProviderWiseGamesOptions(
          games.map(game => ({ value: game.uuid, label: game.name }))
        )
        setGame(null) // Clear the selected game
        setBetsOptions([])
        setDominationOptions([])
      })
      .catch(error => {
        toastr.error(
          error?.response?.data?.message || "Error fetching provider-wise games"
        )
      })
  }

  const fetchGameWiseOptions = gameId => {
    axios
      .get(`${API_URL}/slotegrator/freeSpinbet?game_uuid=${gameId}`)
      .then(response => {
        const { denominations, bets, total_bets } = response?.data || {}

        setGameWiseDominationOptions(
          denominations?.map(denom => ({ value: denom, label: denom }))
        )
        setGameWiseBetsOptions(
          bets?.map(bet => ({ value: bet.bet_id, label: bet.bet_id }))
        )
        setGameWiseTotalBetsOptions(
          total_bets?.map(bet => ({ value: bet.amount, label: bet.amount }))
        )
        if (bets && bets.length > 0) {
          setBetsOptions({ value: bets[0].bet_id, label: bets[0].bet_id })
          set_selected_bet(bets[0])
          set_bets(bets)
        } else {
          setBetsOptions([])
          set_selected_bet({})
          set_bets([])
        }
        setDominationOptions({
          value: denominations[0],
          label: denominations[0],
        })
      })
      .catch(error => {
        toastr.error("Error fetching game-wise options")
      })
    
      
  }
  const select_bet = e => {
    setBetsOptions(e)
    var bet = bets.find(bet => bet.bet_id == e.value)
    set_selected_bet(bet)
  }

  const handleChange = selectedOption => {
    setTimePeriod(selectedOption)
  }

  const getMessageForTimePeriod = () => {
    switch (timePeriod?.value) {
      case "24hrs":
        return "Only customers who registered, deposited xxx, and played 3x rollover of 1st deposit in the last 24 hours will get a free spin."
      case "Weekly":
        return "Only customers who registered, deposited xxx, and played 3x rollover of 1st deposit in the last week will get a free spin."
      case "Monthly":
        return "Only customers who registered, deposited xxx, and played 3x rollover of 1st deposit in the last month will get a free spin."
      default:
        return ""
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Freebets" breadcrumbItem="Create" />
          <Card>
            <h5 className="card-header bg-transparent border-bottom">
              Create Freespin Campaign
            </h5>
            <CardBody>
              <Form onSubmit={handleSubmit}>
                <Row className="mb-4">
                  <Label htmlFor="deposit" className="col-sm-3 col-form-label">
                    Minimum Deposit <span style={{ color: "red" }}>*</span>
                    <i
                      className="mdi mdi-information font-size-18"
                      id="deposit"
                    />
                    <UncontrolledTooltip
                      placement="top"
                      target="deposit"
                      style={{ width: "100%" }}
                    >
                      <p style={{ marginBottom: "0px", textAlign: "left" }}>
                        Minimum deposit amount to be checked in last 24 hours
                      </p>
                    </UncontrolledTooltip>
                  </Label>

                  <Col sm={5}>
                    <input
                      id="deposit"
                      type="number"
                      className="form-control"
                      required
                      value={deposit}
                      onChange={e => setDeposit(e.target.value)}
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Label
                    htmlFor="time_period"
                    className="col-sm-3 col-form-label"
                  >
                    Time Period <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Col sm={5}>
                    <Select
                      id="time_period"
                      options={[
                        { value: "24hrs", label: "24hrs" },
                        { value: "Weekly", label: "Weekly" },
                        { value: "Monthly", label: "Monthly" },
                      ]}
                      onChange={setTimePeriod}
                      classNamePrefix="select2-selection"
                      placeholder="Select a time Period"
                      value={timePeriod}
                    />
                    {formErrors.timePeriod_id && (
                      <FieldValidation
                        errorMessage={formErrors.timePeriod_id}
                      />
                    )}
                    {timePeriod && (
                      <div
                        className="time-period-message m-1"
                       
                      >
                        {getMessageForTimePeriod()}
                      </div>
                    )}
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Label htmlFor="product" className="col-sm-3 col-form-label">
                    Product <span style={{ color: "red" }}>*</span>
                    <i
                      className="mdi mdi-information font-size-18"
                      id="product"
                    />
                    <UncontrolledTooltip
                      placement="top"
                      target="product"
                      style={{ width: "100%" }}
                    >
                      <p style={{ marginBottom: "0px", textAlign: "left" }}>
                        3 x Minimum Deposit used on the product selected in last
                        24 hours
                      </p>
                    </UncontrolledTooltip>
                  </Label>
                  <Col sm={5}>
                    <Select
                      id="product"
                      options={[
                        { value: "Sports", label: "Sports" },
                        { value: "Slotegrator", label: "Slotegrator" },
                      ]}
                      onChange={setProduct}
                      classNamePrefix="select2-selection"
                      placeholder="Select a product"
                      value={product}
                    />
                    {formErrors.product_id && (
                      <FieldValidation errorMessage={formErrors.product_id} />
                    )}
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Label htmlFor="currency" className="col-sm-3 col-form-label">
                    Currency <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Col sm={5}>
                    <Select
                      id="currency"
                      options={[{ value: "ZMW", label: "ZMW" }]}
                      onChange={setSupplier}
                      classNamePrefix="select2-selection"
                      placeholder="Select a currency"
                    />
                    {formErrors.supplier_id && (
                      <FieldValidation errorMessage={formErrors.supplier_id} />
                    )}
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Label htmlFor="provider" className="col-sm-3 col-form-label">
                    Provider <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Col sm={5}>
                    <Select
                      id="provider"
                      options={providerOptions}
                      onChange={setProvider}
                      classNamePrefix="select2-selection"
                      placeholder="Select a provider"
                    />
                    {formErrors.provider_id && (
                      <FieldValidation errorMessage={formErrors.provider_id} />
                    )}
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Label htmlFor="game" className="col-sm-3 col-form-label">
                    Game <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Col sm={5}>
                    <Select
                      id="game"
                      options={providerWiseGamesOptions}
                      onChange={setGame}
                      classNamePrefix="select2-selection"
                      placeholder="Select a game"
                      value={game}
                    />
                    {formErrors.game_id && (
                      <FieldValidation errorMessage={formErrors.game_id} />
                    )}
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Label htmlFor="quantity" className="col-sm-3 col-form-label">
                    Quantity <span style={{ color: "red" }}>*</span>
                    <i
                      className="mdi mdi-information font-size-18"
                      id="Quantity"
                    />
                    <UncontrolledTooltip
                      placement="top"
                      target="Quantity"
                      style={{ width: "100%" }}
                    >
                      <p style={{ marginBottom: "0px", textAlign: "left" }}>
                        Number of freespin rounds to give to User
                      </p>
                    </UncontrolledTooltip>
                  </Label>
                  <Col sm={5}>
                    <input
                      id="quantity"
                      type="number"
                      className="form-control"
                      required
                      value={quanty}
                      onChange={e => setQuanty(e.target.value)}
                    />
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Label
                    htmlFor="domination"
                    className="col-sm-3 col-form-label"
                  >
                    Denomination <span style={{ color: "red" }}>*</span>
                    <i
                      className="mdi mdi-information font-size-18"
                      id="Denomination"
                    />
                    <UncontrolledTooltip
                      placement="top"
                      target="Denomination"
                      style={{ width: "100%" }}
                    >
                      <p style={{ marginBottom: "0px", textAlign: "left" }}>
                        Multiplier that determines the currency value
                      </p>
                    </UncontrolledTooltip>
                  </Label>
                  <Col sm={5}>
                    <Select
                      id="domination"
                      options={gameWiseDominationOptions}
                      onChange={setDominationOptions}
                      classNamePrefix="select2-selection"
                      maxMenuHeight={150}
                      placeholder="Select a domination"
                      value={dominationOptions}
                    />
                    {formErrors.dominationOptions_id && (
                      <FieldValidation
                        errorMessage={formErrors.dominationOptions_id}
                      />
                    )}
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Label htmlFor="bet-id" className="col-sm-3 col-form-label">
                    Bet ID <span style={{ color: "red" }}>*</span>
                    <i
                      className="mdi mdi-information font-size-18"
                      id="bet_id"
                    />
                    <UncontrolledTooltip
                      placement="top"
                      target="bet_id"
                      style={{ width: "100%" }}
                    >
                      <p style={{ marginBottom: "0px", textAlign: "left" }}>
                        Amount which will be given to User
                      </p>
                    </UncontrolledTooltip>
                    <p style={{ color: "grey" }}>
                      (bets_per_line x lines x denomination)
                    </p>
                  </Label>
                  <Col sm={5}>
                    <Select
                      id="bet-id"
                      options={gameWiseBetsOptions}
                      onChange={e => select_bet(e)}
                      classNamePrefix="select2-selection"
                      maxMenuHeight={150}
                      placeholder="Select a bet ID"
                      value={betsOptions}
                    />
                    {formErrors.bet_id && (
                      <FieldValidation errorMessage={formErrors.bet_id} />
                    )}
                    {Object.keys(selected_bet).length > 0 ? (
                      <div className="mt-3 mb-3">
                        {selected_bet.bet_per_line} x {selected_bet.lines} x{" "}
                        {dominationOptions?.value ?? 0} =
                        {selected_bet.bet_per_line *
                          selected_bet.lines *
                          (dominationOptions?.value ?? 0)}
                      </div>
                    ) : null}
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Label
                    htmlFor="total-bets"
                    className="col-sm-3 col-form-label"
                  >
                    Total Bets <span style={{ color: "red" }}>*</span>
                  </Label>
                  <Col sm={5}>
                    <input
                      id="total-bets"
                      type="number"
                      className="form-control"
                      readOnly
                      value={gameWiseTotalBetsOptions?.[0]?.label || ""}
                    />
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Label
                    htmlFor="start-date"
                    className="col-sm-3 col-form-label"
                  >
                    Start Date <span style={{ color: "red" }}>*</span>
                    <i
                      className="mdi mdi-information font-size-18"
                      id="start_date"
                    />
                    <UncontrolledTooltip
                      placement="top"
                      target="start_date"
                      style={{ width: "100%" }}
                    >
                      <p style={{ marginBottom: "0px", textAlign: "left" }}>
                        Time from which the Freespin will be valid from
                      </p>
                    </UncontrolledTooltip>
                  </Label>
                  <Col sm={5}>
                    <input
                      id="start-date"
                      type="datetime-local"
                      className="form-control"
                      onChange={handleStartDateChange}
                      value={start_date}
                    />
                    {formErrors.start_date && (
                      <FieldValidation errorMessage={formErrors.start_date} />
                    )}
                  </Col>
                </Row>

                <Row className="mb-4">
                  <Label htmlFor="end-date" className="col-sm-3 col-form-label">
                    End Date <span style={{ color: "red" }}>*</span>
                    <i
                      className="mdi mdi-information font-size-18"
                      id="end_date"
                    />
                    <UncontrolledTooltip
                      placement="top"
                      target="end_date"
                      style={{ width: "100%" }}
                    >
                      <p style={{ marginBottom: "0px", textAlign: "left" }}>
                        Time to which the Freespin will be valid to
                      </p>
                    </UncontrolledTooltip>
                  </Label>
                  <Col sm={5}>
                    <input
                      id="end-date"
                      type="datetime-local"
                      className="form-control"
                      onChange={handleEndDateChange}
                      value={end_date}
                    />
                    {formErrors.end_date && (
                      <FieldValidation errorMessage={formErrors.end_date} />
                    )}
                  </Col>
                </Row>

                <Row>
                  <Col sm={3}></Col>
                  <Col sm={9}>
                    <Row>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button type="submit" color="primary" className="w-100">
                          Submit
                        </Button>
                      </Col>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button
                          type="button"
                          color="secondary"
                          className="w-100"
                          onClick={() =>
                            props.history.push("/promotions/AutometedFreeSpin")
                          }
                        >
                          Cancel
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export const CreateAutoFreebets = withRouter(Create)
